import React from "react";

export default function LevelDetail({ Icon, iconClassName, label, id }) {
  return (
    id && (
      <li className="flex gap-2 items-center mb-1">
        {Icon && (
          <Icon
            className={iconClassName}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        )}{" "}
        {label}
      </li>
    )
  );
}
